import React from 'react';
import { Navigate } from 'react-router';
import { Authenticator } from '@aws-amplify/ui-react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { authenticatorSettings } from './login/authenticatorSettings';

export const Login = () => {
    const { route, user } = useAuthenticator();

    if (route === 'authenticated' && user) {
        return <Navigate to="/app/home" replace />;
    }

    return <Authenticator {...authenticatorSettings} />;
};
